import { useCallback } from 'react'
import { useCryptoRewardsPaneModifyStateCallback } from 'components/features/rewards/rewardsPane/hooks/useCryptoRewardsPaneModifyFieldsStateCallback'
import { CryptoRewardsPaneModeWithSteps, CryptoRewardsPaneState } from 'components/features/rewards/rewardsPane/types/paneState'

export function useCryptoRewardsPaneModifyState<M extends CryptoRewardsPaneModeWithSteps> (mode: M, buyModePaneState: Partial<CryptoRewardsPaneState<M>>): () => void {
  const callbackModifyState = useCryptoRewardsPaneModifyStateCallback<M>(mode)
  const modifyBuyPaneState = useCallback(() => {
    callbackModifyState(buyModePaneState)
  }, [buyModePaneState, callbackModifyState])

  return modifyBuyPaneState
}
